import api from 'utils/api';

export const requestPricing = (briefId) =>
  api.callGet('admin/adweave-briefs/get-price', {
    id: briefId,
  });

export const requestFormats = (briefId, packageName, version, q) => {
  const params = {
    id: briefId,
  };

  if (packageName) {
    params.package_name = packageName;
  }

  if (version !== undefined && version !== null && version !== '') {
    params.version = version;
  }

  if (q) {
    params.q = q;
  }

  return api.callGet('admin/adweave-briefs/get-formats', params);
};

export const requestTableData = (briefId) =>
  api.callGet('admin/adweave-briefs/table-data', {
    brief_id: briefId,
  });

export const requestPricingCSV = (briefId) =>
  api.callGet(
    'admin/adweave-briefs/get-price',
    {
      id: briefId,
      format: 'csv',
    },
    { responseType: 'blob' }
  );

export const requestSaveFormats = (
  briefId,
  formats,
  isConcepting,
  packageName
) =>
  api.callPost('admin/adweave-briefs/save-formats', {
    brief_id: briefId,
    format_ids: formats,
    is_concepting: isConcepting,
    package_name: packageName,
  });

export const requestSavePackage = ({
  briefId,
  formatIds,
  isConcepting,
  packageName,
}) =>
  api.callPost('admin/adweave-briefs/save-package', {
    brief_id: briefId,
    format_ids: formatIds,
    is_concepting: isConcepting,
    package_name: packageName,
  });

export const requestRenamePackage = ({
  briefId,
  oldPackageName,
  newPackageName,
}) =>
  api.callPost('admin/adweave-briefs/rename-package', {
    brief_id: briefId,
    old_package_name: oldPackageName,
    new_package_name: newPackageName,
  });

// `id` is the brief id when subject is 'cms' (editing section_one...six), or
// the table_data row's own id when subject is 'table_date' (editing a
// service row's service_type/service_description/price).
export const requestCmsUpdate = ({ id, key, value, subject }) =>
  api.callPost('admin/adweave-briefs/cms-update', {
    brief_id: id,
    key,
    value,
    subject,
  });

export const requestUpdatePriceQuantity = ({
  briefId,
  packageId,
  version,
  key,
  value,
}) =>
  api.callPost('admin/adweave-briefs/update-price-quantity', {
    brief_id: briefId,
    package_id: packageId,
    version,
    key,
    value,
  });
